import React from 'react';

const NotFound = () => {
  return <h1>Seite nicht gefunden</h1>;
};

export default NotFound;
